import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { EndpointsService, NotificationService } from "../core/services";

@Injectable()
export class AssetsService {
    private static notificationService;
    constructor(private http: Http, private endpointsService: EndpointsService, private notificationService: NotificationService) {
        AssetsService.notificationService = notificationService;
    }

    public getFilteredAssets(sortFieldId: number, sortAsc: boolean, pageNumber: number, pageSize: number, name: string, publisherIds: number[]): Observable<Response> {
        let url = this.getAssetsUrl(sortFieldId, sortAsc, pageNumber, pageSize, name, publisherIds);
        return this.http.get(url)
            .catch(this.handleError);
    }

    public getProvidersForPublisher(publisherId: number) {
        let url = `${this.endpointsService.GET_PROVIDERS_FOR_PUBLISHER_URL}?publisherId=${publisherId}`;
        return this.http.get(url)
            .catch(this.handleError);
    }

    public createAsset(name: string, publisherId: number,  file: File): Observable<Response> {
        let headers = new Headers();
        headers.append('Accept', 'application/json');
        let formData: FormData = new FormData();
        formData.append('uploadFile', file, file.name);
        formData.append('name', name);
        formData.append('publisherId', publisherId.toString());
        let options = new RequestOptions({ headers: headers });
        return this.http.post(this.endpointsService.CREATE_ASSET_URL, formData, options)
            .catch(this.handleError);
    }

    private getAssetsUrl(sortFieldId: number, sortAsc: boolean, pageNumber: number, pageSize: number, name: string, publisherIds: number[]): string {
        return `${this.endpointsService.GET_ASSETS_URL}?sortFieldId=${sortFieldId}&sortAsc=${sortAsc}&name=${name}&publisherIds=${publisherIds}&pageNumber=${pageNumber}&pageSize=${pageSize}`;
    }

    private handleError(error: Response) {
        if (error.status === 400)
            AssetsService.notificationService.showError(error.json().message)
        else
        AssetsService.notificationService.showError();
        return Observable.throw(error.json().error || 'Server Error');
    }
}


// WEBPACK FOOTER //
// ./src/app/assets/asset.services.ts